import PropTypes from 'prop-types'
import { withLocalize } from 'react-localize-redux'

import { Typography } from '@material-ui/core'

import styles from './AvailableKeysForm.module.scss'

const AvailableKeysForm = props => {
  const { translate, apiLimitKeys, hideModal, user } = props

  const onClickCancel = () => {
    hideModal()
  }

  const openContactSupport = () => {
    const email = user.toJS()?.email
    const destinationEmail = 'inbiotservices@inbiot.es'
    const subject = encodeURIComponent(translate('contactUsAPISubject'))

    let rawBody = translate('contactUsAPIText').replace('$email', email)
    const body = encodeURIComponent(rawBody)

    window.location.href = `mailto:${destinationEmail}?subject=${subject}&body=${body}`
  }

  return (
    <div className={styles.modalContainer}>
      <Typography className={styles.header}>
        {translate('integrationsPage.availableKeys')}
      </Typography>
      <div className={styles.modal}>
        <div className={styles.page}>
          <div className={styles.modalContent}>
            <div>
              <span>{translate('integrationsPage.availableKeysModalText.p1')}</span>
              <span className={styles.key}>{' ' + apiLimitKeys + ' '}</span>
              <span>{translate('integrationsPage.availableKeysModalText.p2')}</span>
            </div>
          </div>
          <div>
            <div className={styles.buttonWrapper}>
              <button
                className={styles.buttonSiguiente}
                onClick={openContactSupport}
              >
                {translate('helpOptions.contactUs').toUpperCase()}
              </button>
              <button
                className={styles.buttonCancelar}
                onClick={onClickCancel}
              >
                {translate('cancel').toUpperCase()}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

AvailableKeysForm.propTypes = {
  translate: PropTypes.func.isRequired
}

export default withLocalize(AvailableKeysForm)
